export default {

  verbose: true,

  green(text) {
    if (this.verbose)
      console.log(`%c${text}`, "color:green");
  },

  red(text) {
    if (this.verbose)
      console.log(`%c${text}`, "color:red");
  },

  blue(text) {
    if (this.verbose)
      console.log(`%c${text}`, "color:blue");
  },

  success(action, status, input, output) {
    const build = '%c %s %c %s %c %s';
    const css1 = 'background: green; color: white; font-weight: bold';
    const css2 = 'background: mediumseagreen; color: white; font-weight: bold'
    const css3 = 'font-weight: bold';
    if (this.verbose)
      console.log(build, css1, `${action}`, css2, `${status}`, css3, `${input}`, output);
  },

  failure(action, status, input, output) {
    const build = '%c %s %c %s %c %s';
    const css1 = 'background: firebrick; color: white; font-weight: bold';
    const css2 = 'background: red; color: white; font-weight: bold'
    const css3 = 'font-weight: bold';
    if (this.verbose)
      console.log(build, css1, `${action}`, css2, `${status}`, css3, `${input}`, output);
  },

}